import { action } from '@ember/object';
import { next } from '@ember/runloop';
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';

import didUpdate from 'webapp/modifiers/did-update';
import FormInputDecimalComponent from 'webapp/components/form/input-decimal';
import GoalsMeasurementForDropdownComponent from 'webapp/components/goals/measurement/for-dropdown';
import RowErrorComponent from 'webapp/components/row-error';

import type { Goal } from 'webapp/models-custom';
import { MAX_TARGET_VALUE_LENGTH } from 'webapp/models-custom/goal';

interface Args {
	model: Goal;
	value: string | null;
	onChange: (value: number | null) => void;
	isDisabled: boolean;
}

export default class GoalsStartingValueComponent extends Component<Args> {
	maxTargetValueLength = MAX_TARGET_VALUE_LENGTH;

	@tracked forceUpdateFromValue = false;

	get model() {
		return this.args.model;
	}

	@action
	change(value: number | null) {
		this.args.onChange(value);
	}

	@action
	updateOnOutsideValueChange() {
		this.forceUpdateFromValue = true;

		next(() => {
			this.forceUpdateFromValue = false;
		});
	}
	<template>
		<div class="input-dropdown" {{didUpdate this.updateOnOutsideValueChange @value}}>
			<FormInputDecimalComponent
				@name="startValue"
				@value={{@value}}
				@onChange={{this.change}}
				@isDisabled={{@isDisabled}}
				@placeholder="Start value"
				@forceUpdateFromValue={{this.forceUpdateFromValue}}
				@maxLength={{this.maxTargetValueLength}}
			/>
			<RowErrorComponent @items={{this.model.errors.startValue}} />
			<GoalsMeasurementForDropdownComponent @model={{this.model}} />
		</div>
	</template>
}
